import React from 'react'
import Bredcrum from '../../common/Bredcrum'
import Faqs from './Faqs';



const FaqIndex = () => {
    return (
        <>
            <Bredcrum
                heading={'Question & Answers'}
                path={[
                    { name: 'faq’s', path: 'faqs' },
                ]}
            />

            <Faqs />


        </>
    )
}

export default FaqIndex